import React from "react";
import background from "./images/background-2.jpg";
import logo from '../../images/logo-big.jpg';
import './styles.css';


const AppPage = (props)=> {

        return (
            <div className='page-wrapper'>
                <nav className="navbar navbar-transparent navbar-absolute">
                    <div className="container">
                        <div className="navbar-header">
                          <span className="navbar-brand" >
                            <img src={logo} alt="AMCEMIG" />
                          </span>
                        </div>
                    </div>
                </nav>

                <div className="wrapper wrapper-full-page">
                    <div
                        className="full-page login-page"
                        data-image={background}>

                        <div className="content">
                            <div className="container">
                                {props.children}
                            </div>
                        </div>

                        <footer className="footer footer-transparent">
                            <div className="container">
                                {/*<div className="copyright">
                                    &copy;{" "}
                                    {new Date().getFullYear()} ,
                                    made with <i className="fa fa-heart heart" /> by{" "}
                                    TIDE
                                </div>*/}
                            </div>
                        </footer>
                        <div className="full-page-background" style={{backgroundImage:`url(${background})`}} />
                    </div>
                </div>
            </div>
        );
};

export default AppPage;



// WEBPACK FOOTER //
// ./src/App/scenes/AppPages/index.js